<template>
<div class="chapter">
<div class="inner_page">
<h1 class="Title" id="heading_id_3"></h1>
<h2 id="heading_id_2">Who You Are When No One’s Looking</h2>
<p class="h3"><em>Choosing Consistency,<br/>
  Resisting Compromise</em><br/>
<br/>
  Revised and Expanded</p>
<p class="h1">Bill Hybels</p>
<p class="h3">Edited by LaVonne Neff<br/>
  Revised edition edited by Ashley Wiersma</p>
<p class="h2"><img alt="IVP Books" src="Images/IVP_Books_Half.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?4597af6d